import { render } from "./ChuThichNgang.vue?vue&type=template&id=4390480a&scoped=true"
import script from "./ChuThichNgang.vue?vue&type=script&lang=js"
export * from "./ChuThichNgang.vue?vue&type=script&lang=js"

import "./ChuThichNgang.vue?vue&type=style&index=0&id=4390480a&lang=scss&scoped=true"
import "./ChuThichNgang.vue?vue&type=style&index=1&id=4390480a&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4390480a"]])

export default __exports__